import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';

export enum PurchaseAbcCurveDateFilterBy {
  issueDate = 'IssueDate',
  releaseDate = 'ReleaseDate',
}

export enum PurchaseAbcCurveImportanceFilterBy {
  amount = 'Amount',
  value = 'Value',
}

export interface PurchaseAbcCurveFormValues extends ReportDateInterface {
  analytical?: boolean;
  dateFilterBy: PurchaseAbcCurveDateFilterBy;
  importanceFilterBy: PurchaseAbcCurveImportanceFilterBy;
}

export interface PurchaseAbcCurveRequest {
  companiesIds?: string;
  startDate: string;
  endDate: string;
  dateFilterBy: PurchaseAbcCurveDateFilterBy;
  importanceFilterBy: PurchaseAbcCurveImportanceFilterBy;
}
